export const EMAIL_REGEX =
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
export const E164_REGEX = /^\+[1-9]\d{1,14}$/;
export const PHONE_INPUT_NUMBER_REGEX = /[+0-9]$/g;
export const POSITIVE_NUMBER_REGEX = /^\d+(\.\d+)?$/;
export const INTEGER_REGEX = /^-?\d+$/;

/**
 * Cho phép chữ cái,
 * chữ số,
 * tối thiểu 1 chữ cái in hoa,
 * tối thiểu 1 chữ số,
 * tối thiểu 1 kí tự đặc biệt,
 * độ dài tối thiểu là 8 kí tự
 */
export const PASSWORD =
  /^(?=(.*[\w]))(?=(.*[A-Z]+))(?=(.*\d))(?=(.*[!@#$%^&*]))[\w\d!@#$%^&*]{8,}$/;

export const USERNAME = /^(?=.{3,})[a-zA-Z][-_a-zA-Z\d]*[a-zA-Z\d]$/;
